import { createAsyncThunk } from "@reduxjs/toolkit";
import {
	getTransactions,
	addTransaction,
	editTransaction,
	removeTransaction,
	getAllTransactions,
} from "./transactionAPI";

export const fetchTransactions = createAsyncThunk(
	"transaction/fetchTransactions",
	async ({ search, currentPage, sortBy }) => {
		const { transactions, pages } = await getTransactions(
			search,
			currentPage,
			sortBy
		);
		return { transactions, pages };
	}
);

export const fetchAllTransactions = createAsyncThunk(
	"transactions/fetchAllTransactions",
	async () => {
		const transactions = await getAllTransactions();

		return transactions;
	}
);

export const createTransaction = createAsyncThunk(
	"transaction/createTransaction",
	async (data) => {
		const transaction = await addTransaction(data);
		return transaction;
	}
);

export const changeTransaction = createAsyncThunk(
	"transaction/changeTransaction",
	async ({ id, data }) => {
		const transaction = await editTransaction(id, data);
		return transaction;
	}
);

export const deleteTransaction = createAsyncThunk(
	"transaction/deleteTransaction",
	async (id) => {
		const transaction = await removeTransaction(id);
		return transaction;
	}
);
